import React from "react";
import PropTypes from "prop-types";

class SortableHeader extends React.Component {
  shouldComponentUpdate(nextProps) {
    const { field, sortedField: currentSortedField } = this.props;
    const { sortedField } = nextProps;
    return field === sortedField || field === currentSortedField;
  }

  render() {
    const {
      field,
      labels,
      sort,
      width,
      sortedField,
      align,
      isAsc,
      showSortLabel,
      classNames,
      isSortable,
    } = this.props;
    const isActiveClass = field === sortedField ? "active" : "";
    const justifyClass =
      align === "center" ? "tw-justify-center" : "tw-justify-start";
    const title = isAsc ? "Sort Ascending" : "Sort Descending";
    const sortText = isAsc ? "ASC" : "DSC";
    const iconClass = isAsc ? "" : "tw-transform tw-rotate-180";
    return (
      <th
        data-testid={`sortable-header-${field}`}
        onClick={() => sort(field)}
        width={width}
        className={`th-sort hover ${align} ${isActiveClass}`}
      >
        <div
          className={`tw-flex tw-full-width tw-items-center tw-cursor-pointer ${justifyClass}`}
        >
          <div className={`select-none ${classNames}`}>{labels[field]}</div>
          <div className="sort-container no-underline no-print" title={title}>
            {showSortLabel ? (
              <div
                data-testid={`sortable-header-text-${field}`}
                className="sort-dir"
              >
                {sortText}
              </div>
            ) : null}
            {isSortable && (
              <div
                className={`sort-icon-container tw-transition-transform ${iconClass}`}
              >
                <i className="varsome-icons icon-chevron-up" />
              </div>
            )}
          </div>
        </div>
      </th>
    );
  }
}

SortableHeader.propTypes = {
  labels: PropTypes.shape({}),
  field: PropTypes.string,
  sort: PropTypes.func.isRequired,
  width: PropTypes.string,
  sortedField: PropTypes.string,
  align: PropTypes.string,
  isAsc: PropTypes.bool,
  showSortLabel: PropTypes.bool,
  classNames: PropTypes.string,
  isSortable: PropTypes.bool,
};

SortableHeader.defaultProps = {
  labels: {},
  width: null,
  field: null,
  sortedField: null,
  align: "left",
  isAsc: true,
  showSortLabel: true,
  classNames: "tw-font-bold font-cabin",
  isSortable: true,
};

export default SortableHeader;
